export const convertArrayToObject = (array: object[], key: string) =>
  array.reduce((obj, item) => {
    if (!Array.isArray(obj[item[key]])) {
      obj[item[key]] = []
    }
    obj[item[key]].push({ ...item })
    return obj
  }, {})

export const convertArrayToObjectNoDuplicateKey = (array: Record<string, any>[], key: string, dataKey: string) =>
  array.reduce((acc, item) => {
    acc[item[key]] = item[dataKey]
    return acc
  }, {})
